/**
 * Application Configuration
 * Central place for all configuration constants
 *
 * BASE_DOMAIN is resolved automatically:
 *   1. REACT_APP_BASE_DOMAIN env var (set at build time) — explicit override
 *   2. Local development (npm start) — backend on localhost:3001
 *   3. Deployed builds — same origin the app is served from
 * 
 * 
 *      (develop/staging/production each get their own domain automatically,
 *      so this file never needs to differ between branches)
 */

export const BASE_DOMAIN =


  process.env.REACT_APP_BASE_DOMAIN ||
  (process.env.NODE_ENV === 'development'
    ? 'http://localhost:3001'
    : window.location.origin);

// Raw API Base (for custom API paths)
export const API_BASE = `${BASE_DOMAIN}/api`

// Admin API (requires authentication)
export const API_BASE_URL = `${BASE_DOMAIN}/api/v1/admin/`

// Public API (customer portal - no auth required)
export const PUBLIC_API_BASE_URL = `${BASE_DOMAIN}/api/v1/public`

// Customer Portal URL
export const CUSTOMER_PORTAL_URL = `${BASE_DOMAIN}/customer-portal`

// Assets URL
export const ASSETS_URL = `${BASE_DOMAIN}/assets`

// Export default config object
export default {
  BASE_DOMAIN,
  API_BASE,
  API_BASE_URL,
  PUBLIC_API_BASE_URL,
  CUSTOMER_PORTAL_URL,
  ASSETS_URL,
};
